import React from "react";
import { Row, Col, Input, Form } from "antd";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
import { strings, parsePlace } from "../../helpers";

const FormItem = Form.Item;

const searchOptions = {
  componentRestrictions: { country: "in" },
  types: ["(cities)"]
};

export default class AddressView extends React.Component {
  /**
   * @function handleSelect
   * @param address
   * @desc This function triggers when a place is selected
   * from the google places dropdown, it sets state variables accordingly
   */
  handleSelect = address => {
    let location = {
      city: ""
    };

    geocodeByAddress(address)
      .then(results => {
        const finalLocation = parsePlace(results[0].address_components);
        this.props.form.setFieldsValue({
          state: finalLocation.state,
          city: finalLocation.city
        });

        getLatLng(results[0]).then(({ lat, lng }) => {
          location = {
            city: results[0].formatted_address,
            state: finalLocation.state
          };
          this.props.setCity(location);
        });
      })
      .catch(() => {});
  };

  /**
   * @function handleMapError
   * @param e
   * @desc This function handles error logging
   */
  handleMapError = e => {};

  render() {
    const { getFieldDecorator } = this.props.form;
    const { selectedRecord } = this.props;

    return (
      <PlacesAutocomplete
        value={this.props.address}
        onChange={this.props.handleCityChange}
        onSelect={this.handleSelect}
        searchOptions={searchOptions}
        onError={this.handleMapError}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps }) => (
          <Row type="flex" gutter={16}>
            <Col span={12}>
              <FormItem label={strings.profile.city}>
                {getFieldDecorator("city", {
                  initialValue:
                    selectedRecord && selectedRecord.city
                      ? selectedRecord.city
                      : "",
                  rules: []
                })(
                  <div className="places-box">
                    <Input
                      {...getInputProps({
                        placeholder: strings.profile.searchPlaces,
                        className: "location-search-input"
                      })}
                      value={this.props.city}
                    />
                    <div className="autocomplete-dropdown-container">
                      {/* {loading && <div>Loading...</div>} */}
                      {suggestions.map(suggestion => {
                        const className = suggestion.active
                          ? "suggestion-item--active suggestion-box"
                          : "suggestion-item suggestion-box";

                        return (
                          <div
                            {...getSuggestionItemProps(suggestion, {
                              className
                            })}
                          >
                            <span>{suggestion.description}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label={strings.profile.state}>
                {getFieldDecorator("state", {
                  initialValue:
                    selectedRecord && selectedRecord.state
                      ? selectedRecord.state
                      : ""
                })(<Input value={this.props.state} />)}
              </FormItem>
            </Col>
          </Row>
        )}
      </PlacesAutocomplete>
    );
  }
}
